import React, { FC, HTMLProps, ReactNode } from 'react'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import s from './MainCard.module.sass'
import Link from 'next/link'
import IconChevronLong from '@icons/icon-selection-chevron--big.svg'
import { ChevronWithTooltip } from '@shared/ui/Feedback/ChevronWithTooltip'
import { MediaImg } from '../../../Media/MediaImg'

interface Props {
  img: string
  alt: string
  href: string
  sizes?: string // XL - desktop, S - mobile
  chevron?: boolean
  classNameWrapper?: string
  classNameContent?: string
  children: ReactNode
}

const MainCard: FC<Props & HTMLProps<HTMLDivElement>> = React.forwardRef(
  (
    { img, href, alt, sizes = 'XL S', chevron, classNameWrapper = '', classNameContent = '', children, ...props },
    ref,
  ) => {
    const [size] = useCurrentSize(sizes)
    const borderRadius = { XL: '32px', S: '20px' }
    return (
      <ErrorBoundary>
        {/*// @ts-ignore*/}
        <Link
          href={href}
          className={`${s.card} ${classNameWrapper}`}
          data-chevron={chevron}
          data-cover-size={size}
          scroll={false}
          title={alt}
          {...props}>
          {chevron && <ChevronWithTooltip icon={IconChevronLong} className={s.chevron} />}

          <MediaImg
            image={{
              Url: img,
              Width: 500,
              Height: 500,
              Crop: null,
              Description: alt,
              Copyright: null,
              Author: null,
            }}
            objectId={Number(img)}
            height={500}
            width={500}
            flexible={true}
            className={s['img-wrapper']}
            dimmed={'gradient'}
            borderRadius={borderRadius[size]}
          />

          <div className={`${s.content} ${classNameContent}`} ref={ref}>
            {children}
          </div>
          <div className={s['backdrop-wrap']} data-cover-size={size}>
            <div className={s.backdrop} data-cover-size={size} style={{ backgroundImage: `url(${img})` }} />
          </div>
        </Link>
      </ErrorBoundary>
    )
  },
)

MainCard.displayName = 'MainCard'

export default MainCard
